export const moduleTestingPermissions = {
	account_management_business_units: false,
	account_management_clients: false,
	stock: false,
	vessels_site: false,
	project_overview: false,
	account_management_users: true,
	account_management_roles: false,
	account_management_resellers: false,
	account_management_account_numbers: false,
};
